'use strict';

import React, { Component, Fragment } from 'react'

import getErrorsFromResponse from '@/Form/Functions/getErrorsFromResponse'

import Pagination from '@/Pagination'

import CheckedIcon from '@/Icons/Checked'
import SortIcon    from '@/Icons/Sort'

import bemit from '@function/bemit'

import Loader from '@Pure/Loader'

const app = window.app;

const qwest = window.qwest;

export default class Dashboard extends Component
{
	state =
	{
		loading: true,

		data: [],
		data_count: 0,

		page: 0,
		rows_per_page: this.props['items-per-page'] || 10,

		order: this.props.order || 'desc',
		order_by: this.props['order-by'] || 'createdAt',

		searched: '',

		status_messages: { },

		selected: { }
	};

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		component.fetchData({ });

		if (props['request-update'])
		{
			app.push(
			{
				event: props['request-update'],
				cb: component.requestUpdate
			});
		}
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		if (props['request-update'])
		{
			app.delete(
			{
				event: props['request-update'],
				cb: component.requestUpdate
			});
		}
	}

	requestUpdate = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.fetchData({ });
	}

	componentDidUpdate (prev_props, prev_state)
	{
		const component = this, props = this.props, state = this.state;

		const prev_filters = prev_props.filters || { };

		const changes = Object.keys(props.filters || { })
		.some(function (field)
		{
			if (!props.filters[field] && !prev_filters[field]) return false;

			return props.filters[field] !== prev_filters[field];
		});

		if (changes) component.fetchData({ page: 0 });
	}

	fetchData = ({ page, order, order_by }) =>
	{
		const component = this, props = this.props, state = this.state;

		const current_page = typeof page === 'undefined'
		? state.page
		: page;

		let update = { };

		[page, order, order_by].filter(prop => typeof prop !== 'undefined')
		.forEach(prop => update[prop] = prop);

		component.setState(
		{
			...update,

			loading: true,

			selected: { }
		});

		const results_for =
		{
			...(props.filters || { })
		};

		qwest.post(props.url,
		{
			limit: state.rows_per_page,
			skip: state.rows_per_page * current_page,
			with_count: true,

			...(props.filters || { }),

			order: order || state.order,
			order_by: order_by || state.order_by
		})
		.then(function (xhr, response)
		{
			if (order) component.setState({ order: order });

			if (order_by) component.setState({ order_by: order_by });

			if (typeof props.onSelection === 'function')
			{
				props.onSelection();
			}

			if (typeof props.onFetched === 'function')
			{
				props.onFetched(
				{
					response,

					data: response.data,
					count: response.count,

					results_for: results_for
				});
			}

			if ((response.count || 0) < state.rows_per_page)
			{
				component.setState({ page: 0 });
			}

			component.setState(
			{
				loading: false,

				results_for: results_for,

				data_count: response.count || 0,
				data: response.data || []
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState(
			{
				...getErrorsFromResponse(
				{
					response: response
				})
			});
		});
	}

	handlePageChange = (e, page) =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.loading === true) return;

		component.setState({ page: page });

		component.fetchData({ page: page });
	}

	sort (e, field)
	{
		const component = this, props = this.props, state = this.state;

		if (state.loading === true) return;

		const order_by = field;

		let order = 'desc';

		if (state.order_by === order_by && state.order === 'desc')
		{
			order = 'asc';
		}

		component.fetchData(
		{
			order: order,
			order_by: order_by
		});
	}

	toggleSelection = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

		state.selected[data.id] = !state.selected[data.id];

		component.setState(
		{
			selected: state.selected
		});

		props.onSelection(e, data);
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const Row = props.component || undefined;

		let data = [];

		if (Row)
		{
			data = state.data.map(function (data)
			{
				const selection = props.onSelection ?
				(
					<button className="c-dashboard__cell selection"
						onClick={ (e) => component.toggleSelection(e, data) }>
						<span className="u-readers-only">
							Cocher
						</span>
						{
							state.selected[data.id] ?
							(
								<CheckedIcon className="c-dashboard__selected" />
							)
							: undefined
						}
					</button>
				)
				: undefined;

				const output =
				(
					<Row data={ data } key={ data.id } blank={ props.blank }
						fields={ props.fields } { ...(props['row-props'] || { }) }
						results-for={ state.results_for }>

						{ selection }

					</Row>
				);

				return output;

			});
		}
		else if (typeof props.render === 'function')
		{
			data = state.data.map(data => props.render(data));
		}
		else
		{
			return null;
		}

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
		)
		: undefined;

		const header = (props.header || []).map(function (field)
		{
			let classes = 'c-dashboard__cell';

			const sortable = props['disable-sort'] !== true &&
				field.sortable !== false;

			if (sortable) classes += ' ' + 'sortable';

			classes += ' ' + props.model + '-' + field.name.split('.').join('_');

			let sort_class = 'c-dashboard__sort';

			if (field.align && field.align !== 'left')
			{
				classes += ' u-content-' + field.align;
			}

			if (state.order_by === field.name)
			{
				classes += ' ' + state.order;
			}

			const sort_indicator = state.order_by === field.name ?
			(
				<Fragment>
					<SortIcon className="c-dashboard__sort-icon" />
					<div className="c-dashboard__sort-arrow" />
				</Fragment>
			)
			: undefined;

			const sort_btn = sortable ?
			(
				<button className={ sort_class }
					onClick={ (e) => component.sort(e, field.name)}>
					{ field.label }
					{ sort_indicator }
				</button>
			)
			: field.label;

			let output =
			(
				<div key={ field.name } className={ classes }>

					{ sort_btn }

				</div>
			);

			return output;
		});

		const model_name = props.model.toLowerCase();

		const modifiers = (props.bemit || []).slice(0);

		if (props.condensed) modifiers.push('condensed');

		let output =
		(
			<Fragment>

				<div className="dashboard-wrapper">

					<div className={ bemit('c-dashboard', ['head', model_name]
						.concat(modifiers)) }>

						<div className="c-dashboard__row">

							{

								props.onSelection ?
								(
									<div className="c-dashboard__cell selection" />
								)
								: undefined
							}

							{ header }

						</div>

					</div>

					<div className={ bemit('c-dashboard', [model_name]
						.concat(modifiers)) }>

						{ data }

						{ props['total-lines'] }

						{ loader }

					</div>

				</div>

				{
					props.pagination !== false ?
					(
						<Pagination current={ state.page } total={ state.data_count }
							items-per-page={ state.rows_per_page }
							onChange={ component.handlePageChange }
						/>
					)
					: undefined
				}

			</Fragment>
		);

		return output;
	}
}